<template>
  <!-- 轮播图 -->
  <div class="home-wrap">
    <div class="swiper" v-if="scrollImgList.length">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in scrollImgList"
          :key="index"
        >
          <img
            style="width: 100%; height: 350px; border-radius: 5px"
            :src="item.url"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 数据统计 -->
    <div class="statistics-wrap">
      <div
        class="statistics-item"
        v-for="(item, index) in sumData"
        :key="index"
      >
        <div class="content">
          <p class="title">{{ item.label }}</p>
          <p class="value">{{ item.value }}</p>
        </div>
        <div v-if="index < sumData.length - 1" class="shu"></div>
      </div>
    </div>

    <!-- 资源 -->
    <div class="resources-wrap" @click="uploadResource">
      <div class="upload-resources">+上传资源</div>
    </div>

    <!-- 底部 -->
    <div class="footer">
      Copyright © 2004-2022 北京众行华企科技有限公司 | 京ICP备12005314号-5 |
      上海知众云数字科技有限公司提供技术支持
    </div>

    <wan-drawer ref="wanDrawer" :drawer-params="drawerParams"></wan-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import wanDrawer from "@/components/wan-drawer";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",

  components: {
    wanDrawer,
  },

  data() {
    return {
      // 数据统计
      sumData: [],

      scrollImgList: [],

      // 给弹窗的参数
      drawerParams: {
        title: "上传资源",
        drawerType: 1,
      },
    };
  },

  computed: {
    ...mapState(["userInfo"]),
  },

  mounted() {
    // 轮播图
    this.getBanner();
    // 数据统计
    this.getSumData();
  },

  methods: {
    // 上传资源
    uploadResource() {
      const remainDays = this.$utils.dateDiff();
      if (remainDays <= 0) {
        return this.$router.push({
          path: "/spacePay",
        });
      }
      this.$refs.wanDrawer.drawerVisible = true;
    },

    // 轮播图
    async getBanner() {
      this.$store.commit("setLoading", true);
      this.scrollImgList = [];
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(`PC_BANNER5_${i + 1}`);
      }
      let data = await this.$http.getKeyPicList(list.toString());
      list.forEach((item) => {
        this.scrollImgList.push({
          url: data[item].url,
        });
      });
      this.$store.commit("setLoading", false);

      this.$nextTick(() => {
        // eslint-disable-next-line no-undef
        new Swiper(".swiper", {
          loop: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
        });
      });
    },

    // 数据统计
    getSumData() {
      this.$store.commit("setLoading", true);
      this.$http
        .getSumData({
          userId: this.userInfo.id,
        })
        .then(({ data }) => {
          this.sumData = [
            { label: "资源", value: data.totalResoureNum + "个" },
            { label: "档夹", value: data.totalCaseNum + "个" },
            {
              label: "学习",
              value:
                data.totalStudyNum > 10000
                  ? data.totalStudyNum / 10000 + "万次"
                  : data.totalStudyNum + "次",
            },
            { label: "转发", value: data.totalForwardNum + "次" },
            {
              label: "曝光",
              value:
                data.totalExposureNum > 10000
                  ? data.totalExposureNum / 10000 + "万次"
                  : data.totalExposureNum + "次",
            },
          ];
          this.$store.commit("setLoading", false);
        });
    },
  },
};
</script>

<style scoped lang="less">
.swiper {
  width: 100%;
  height: 350px;
}

.home-wrap {
  position: relative;
  height: calc(100vh - 125px);

  .statistics-wrap {
    width: 100%;
    height: 150px;
    background: #ffffff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 0 0 0 80px;
    box-sizing: border-box;
    margin: 30px 0;

    .statistics-item {
      display: flex;

      .content {
        .title {
          color: #7a7b7c;
        }

        .value {
          margin-top: 11px;
          font-size: 30px;
          font-weight: bold;
        }
      }

      .shu {
        width: 2px;
        height: 60px;
        background: #acadae;
        border-radius: 5px;
        margin: 0 50px 0 74px;
      }
    }
  }

  .resources-wrap {
    .upload-resources {
      width: 100%;
      height: 150px;
      background: #ffffff;
      border-radius: 5px;
      line-height: 150px;
      text-align: center;
      font-size: 30px;
      font-weight: 400;
    }
  }

  .footer {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #acadae;
    border-radius: 5px 5px 5px 5px;
    opacity: 1;
    //font-size: 20px;
    color: #fff;
    position: absolute;
    bottom: 20px;
  }
}
</style>
